import React, { useRef } from "react";
import { Link } from "@quintype/components";
import { func, array, object } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";
import { differenceInHours } from "date-fns";

import TopArrowContainer from "../../atoms/TopArrowContainer";
import PublishedAt from "../../atoms/PublishedAt";
import More from "../../atoms/More";

import { useOuterClickNotifier } from "../../utils/utils";
import { staticTexts } from "../../utils/Translate";

import "./notifications.m.css";

const Notifications = ({ closeView, notifications, publisherAttributes }) => {
  const viewRef = useRef(null);

  useOuterClickNotifier(closeView, viewRef);
  const latestNotifications = notifications.filter(
    item => differenceInHours(new Date(), new Date(item.created_time + " GMT".toLocaleString())) <= 48
  );

  return (
    <div styleName="notifications-dropdown" ref={viewRef}>
      <TopArrowContainer className="notifications" closeView={closeView}>
        {latestNotifications.length > 0 ? (
          <ul className="notifications-list">
            {latestNotifications.slice(0, 3).map((item, index) => {
              const sentTime = item.created_time + " GMT";

              return (
                <li className="notifications-list-item" key={index}>
                  <Link href={item.notification_url}>
                    <div className="notification-title">{item.notification_title}</div>
                    <PublishedAt date={new Date(sentTime.toLocaleString())} className="notification-story-date" />
                  </Link>
                </li>
              );
            })}
          </ul>
        ) : (
          <div className="no-notifications">There are no notifications</div>
        )}
        {latestNotifications.length > 3 && (
          <Link
            href="/notifications"
            styleName={`load-more-view ${publisherAttributes.lang === "en" ? "en-load-more-view" : ""}`}
          >
            <More type="load-more" text={staticTexts(publisherAttributes.lang).loadMore} />
          </Link>
        )}
      </TopArrowContainer>
    </div>
  );
};

Notifications.propTypes = {
  closeView: func,
  publisherAttributes: object,
  notifications: array
};

const mapStateToProps = state => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
});

export default connect(mapStateToProps, null)(Notifications);
